import TypeValue from "./TypeValue";
import {keys} from "../config/nameSpacesKeys";

export default class Temporal {
  constructor(name, initialValue, namespace, startDateNameSpace, endDateNameSpace) {
    this.namespace=namespace;
    this.name=name;
    this.startDateNameSpace=startDateNameSpace;
    this.endDateNameSpace=endDateNameSpace;
    this.startDate=new TypeValue("startDate", null, startDateNameSpace, keys.dateType);
    this.endDate=new TypeValue("endDate", null, endDateNameSpace, keys.dateType);
    this.type="@type";
    this.typeValue=keys.periodOfTime;
    if (initialValue) {
      this.parseInputJSON(initialValue);
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getExpandedFormatValue() {
    const obj={};
    obj[this.type]=[this.typeValue];
    obj[this.startDateNameSpace]=this.startDate.getExpandedFormatValue();
    obj[this.endDateNameSpace]=this.endDate.getExpandedFormatValue();
    return obj;
  }

  parseInputJSON(inputJSON) {
    if (!inputJSON) {
      return;
    }
    const obj=inputJSON; // [this.namespace];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value=entry[1];
        this.setValueObj(value);
      }
    } else {
      this.setValueObj(obj);
    }
  }

  setValueObj(obj) {
    this.startDate.parseInputJSON(obj);
    this.endDate.parseInputJSON(obj);
    this.typeValue=obj[this.type][0];
  }

  isEmpty() {
    return this.startDate.isEmpty()&&this.endDate.isEmpty();
  }
}
